import { Component, Input } from "@angular/core"

@Component({
    selector: "app-card-content-project-name",
    templateUrl: "./card-content-project-name.component.html",
    styleUrls: ["./card-content-project-name.component.less"],
})
export class CardContentProjectNameComponent {
    @Input() text: string = ""
}
